module.exports = __webpack_public_path__ + "static/media/13.6b178df9.png";